import { Button } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import type { PharmacyPickerNoResultsRecovery } from "~/features/products/pharmacy-picker/pharmacy-picker.types";
import { PharmacyPickerAvailableCount } from "~/features/products/pharmacy-picker/pharmacy-picker-available-count.component";

export function PharmacyPickerNoResultsMessage({
	recovery,
}: {
	recovery?: PharmacyPickerNoResultsRecovery;
}) {
	const { t } = useTranslation("product");
	const kindLabel = recovery
		? t(`vendor.picker.noResults.kind.${recovery.kind}`)
		: "";
	return (
		<div
			className="flex flex-col gap-6"
			data-testid="pharmacy-picker-no-results-message"
		>
			{recovery ? (
				<PharmacyPickerAvailableCount count={0} total={recovery.totalCount} />
			) : null}
			{/* Title and its explanation read as one block, so they share a wrapper
			    rather than the 24px the count and the CTA are held at. */}
			<div className="flex flex-col">
				<p className="text-body-bold text-gray-700">
					{t("vendor.picker.noResults.title")}
				</p>
				<p className="text-caption text-gray-500">
					{recovery
						? t("vendor.picker.noResults.descriptionWithCta", {
								kind: kindLabel,
							})
						: t("vendor.picker.noResults.description")}
				</p>
			</div>
			{recovery ? (
				<Button
					type="button"
					variant="primary"
					className="w-full"
					onClick={recovery.onDiscoverAll}
					data-testid="pharmacy-picker-discover-all"
				>
					{t("vendor.picker.noResults.cta", { kind: kindLabel })}
				</Button>
			) : null}
		</div>
	);
}
